import { combineReducers } from 'redux';

import {
  IMPORT_SCHEDULE_LOADING,
  IMPORT_SCHEDULE_SUCCESS,
  IMPORT_SCHEDULE_ERROR
} from '../actions/importScheduleAction';

const importScheduleLoading = (state = false, action) => {
  switch (action.type) {
    case IMPORT_SCHEDULE_LOADING:
      return action.importScheduleLoading;
    default:
      return state;
  }
};

const importScheduleSuccess = (state = false, action) => {
  switch (action.type) {
    case IMPORT_SCHEDULE_SUCCESS:
      return action.importScheduleSuccess;
    default:
      return state;
  }
};

const importScheduleData = (state = [], action) => {
  switch (action.type) {
    case IMPORT_SCHEDULE_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const importScheduleError = (state = false, action) => {
  switch (action.type) {
    case IMPORT_SCHEDULE_ERROR:
      return action.importScheduleError;
    default:
      return state;
  }
};

const importScheduleReducer = combineReducers({
  importScheduleLoading,
  importScheduleSuccess,
  importScheduleData,
  importScheduleError
});

export default importScheduleReducer;